import React from 'react';
import { Card, CardContent, Icon, Typography, Box } from '@mui/material';
import IntlMessages from '@projectK/helpers/IntlMessages';

const SubMenu = ({ data, activeSubMenu, handleSubMenuClick, companyTheme }) => {
  return data?.children.map((item) => (
    <Card
      variant='outlined'
      sx={{
        '&.tab-item.active': {
          backgroundColor: companyTheme ? companyTheme.primary.main : '#2196f3',
          color: companyTheme ? companyTheme.secondary.main : '#000000',
        },
      }}
      onClick={() => handleSubMenuClick(item.url)}
      className={`tab-item ${activeSubMenu === item.url ? 'active' : ''}`}
    >
      <CardContent>
        {item.icon && (
          <Box component='span' mr={3.25}>
            <Icon color='action' className={'nav-item-icon'}>
              {item.icon}
            </Icon>
          </Box>
        )}
        <Typography gutterBottom variant='h2' component='div'>
          <IntlMessages id={item.messageId} />
        </Typography>
      </CardContent>
    </Card>
  ));
};

export default SubMenu;
